/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useMemo } from 'react';
import { ModelManager } from '@adobe/aem-spa-page-model-manager';
import { PageContext, LoadedCompContext } from '@marriott/mi-trc-components';
import { pageInitialData, CustomModelClient } from '@marriott/mi-trc-components/utils';
import { canUseDOM, UserSessionProvider, logger } from '@marriott/mi-headless-utils';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import '../import-components';
declare global {
  interface Window {
    jQuery: unknown;
    $: any;
    deployedEnvType: string;
  }
}
if (canUseDOM) window.$ = window.jQuery = require('jquery-slim/dist/jquery.slim.min.js');

const modelClient = new CustomModelClient(process.env.NEXT_PUBLIC_AEM_HOST);
if (process.env.NODE_ENV !== 'test') {
  ModelManager.initializeAsync({
    modelClient,
  });
}
const App = function (props) {
  const { log } = logger({})('_app');
  const { Component, pageProps } = props;
  log.debug('[STEP 1] App component', Component, process.env);
  log.debug('[STEP 1] App pageProps', pageProps);

  log.debug('_app.tsx client side: ', props, pageProps);

  const { sessionData, resolvedUrl, requestId, currentLocale } = pageProps;
  const [pageState, setPageState] = useState<any>(pageInitialData);
  const [loadedCompState, setLaodedCompState] = useState<string[]>([]);
  const setEnvVars = useClientEnvVarsStore(state => state.setEnvVars);
  // adding dummy variable to fulfill empty env vars condition in session provider.
  // This needs to read from environemnt variables once websdk is enabled for this product
  const envVars = {
    NEXT_PUBLIC_ENABLE_WEBSDK: 'false',
  };
  setEnvVars?.(envVars);

  const memoLoadedCompContextValue = useMemo(() => {
    const updateLoadedComponents = (componentName: string) => {
      if (!loadedCompState.includes(componentName)) {
        setLaodedCompState(preState => {
          return [...preState, componentName];
        });
      }
    };
    return { loadedCompState, updateLoadedComponents };
  }, [loadedCompState]);

  const memoPageContexValue = useMemo(() => {
    const updateComponentState = ({
      componentName,
      newState,
    }: {
      componentName: string;
      newState: Record<string, any>;
    }) => {
      setPageState(preState => {
        return { ...preState, [componentName]: newState };
      });
    };

    const updatePageErrors = ({ componentName, errors }) => {
      setPageState(preState => {
        return {
          ...preState,
          pageLevelErrors: {
            ...preState.pageLevelErrors,
            [componentName]: errors,
          },
        };
      });
    };
    return {
      pageState,
      setPageState,
      updateComponentState,
      updatePageErrors,
      sessionData,
      resolvedUrl,
      requestId,
      currentLocale,
    };
  }, [pageState, setPageState, sessionData, resolvedUrl, requestId, currentLocale]);

  return (
    <UserSessionProvider pageProps={pageProps}>
      <LoadedCompContext.Provider value={memoLoadedCompContextValue}>
        <PageContext.Provider value={memoPageContexValue}>
          {/* Add loading Aria Label from AEM gloabl label */}
          {/* <ProgressLoaderProvider coverPage={true} loadingAriaLabel="Please wait, loading content."> */}
          <Component {...pageProps} />
          {/* </ProgressLoaderProvider> */}
        </PageContext.Provider>
      </LoadedCompContext.Provider>
    </UserSessionProvider>
  );
};

export default App;
